@if (tipoEstadoProyecto.codigo === 'publicado') {
  <div
    class="d-inline-flex bg-semantic-info-100 border-radius-25 primary-900 p3-medium px-3 py-1">
    {{tipoEstadoProyecto.nombre}}
  </div>
}

@if (tipoEstadoProyecto.codigo === 'privado') {
  <div
    class="d-inline-flex bg-secondary-venture-400 border-radius-25 primary-900 p3-medium px-3 py-1">
    {{tipoEstadoProyecto.nombre}}
  </div>
}

@if (tipoEstadoProyecto.codigo === 'financiado') {
  <div
    class="d-inline-flex bg-primary-300 border-radius-15 primary-900 p3-medium px-3 py-1">
    {{tipoEstadoProyecto.nombre}}
  </div>
}